const multiplierFibonacci = (currentMultiplier: number, resultMultipler: number = 1) => {
  let [a, b, temp] = [1, 0, 0];

  while (a <= currentMultiplier / resultMultipler) {
    temp = a;
    a += b;
    b = temp;
  }

  return a * resultMultipler;
};

export default multiplierFibonacci;
